export default __webpack_public_path__ + "static/media/Mobilization-position.e0b2f767.svg";